// src/router/planningRoutes.js
import PlanningView from "@/views/Planning/PlanningView.vue";
import PlanningList from "@/components/Planning/PlanningList.vue";
import MeetingList from "@/components/Planning/MeetingList.vue";
import LoginView from "@/views/Planning/LoginView.vue";
import MeetingConfirmation from "@/views/Planning/MeetingConfirmation.vue";
import { usePlanningStore } from "@/store/planningStore";
import CandidacyPlanningView from "@/views/Planning/CandidacyPlanningView.vue";
import { planningReturnTo } from "./returnTo";
import RouteEnum from "@/router/RouteEnum";

// Guard d'authentification
const requireAuth = (to, from, next) => {
  const planningStore = usePlanningStore();

  if (planningStore.initAuth()) {
    const contactId = to.query.candidatContactObjId;
    if (typeof contactId === "string" && /^[1-9][0-9]*$/.test(contactId)) {
      planningStore.setCandidatContactObjId(contactId);
    }
    next();
  } else {
    next({ name: RouteEnum.PLANNING_LOGIN, query: { returnTo: to.fullPath } });
  }
};

const planningRoutes = [
  {
    // Page de connexion - pas de guard d'auth
    path: "/planning/login",
    name: RouteEnum.PLANNING_LOGIN,
    component: LoginView,
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      if (to.query.candidatContactObjId && !to.query.token) {
        next(`/planning/candidatures/${encodeURIComponent(to.query.candidatContactObjId)}`);
        return;
      }
      const planningStore = usePlanningStore();
      if (!to.query.token && planningStore.initAuth()) {
        next(planningReturnTo(to.query.returnTo));
        return;
      }
      next();
    },
  },
  {
    path: "/planning/candidatures/:candidatContactObjId([1-9][0-9]*)",
    name: "PlanningCandidacy",
    component: CandidacyPlanningView,
    beforeEnter: requireAuth,
    props: true,
  },
  {
    path: "/planning",
    name: "PlanningEntry",
    component: CandidacyPlanningView,
  },
  {
    path: "/meeting/confirm",
    name: RouteEnum.MEETING_CONFIRMATION,
    component: MeetingConfirmation,
    meta: { requiresAuth: false },
  },
  {
    path: "/:ofObjId/:userAccountObjId/planning/index",
    name: RouteEnum.PLANNING_VIEW,
    component: PlanningView,
    beforeEnter: requireAuth,
    meta: { requiresAuth: true },
    props: (route) => ({
      ofObjId: Number(route.params.ofObjId),
      userAccountObjId: Number(route.params.userAccountObjId),
    }),
  },
  {
    // Ici pas de params : on arrive sans connaître ofObjId
    path: "/:ofObjId/:userAccountObjId/planning/getList",
    name: RouteEnum.PLANNING_LIST,
    component: PlanningList,
    beforeEnter: requireAuth,
    meta: { requiresAuth: true },
    props: (route) => ({
      ofObjId: Number(route.params.ofObjId),
      userAccountObjId: Number(route.params.userAccountObjId),
    }),
  },
  {
    // Ici pas de params : on arrive sans connaître ofObjId
    path: "/:ofObjId/:userAccountObjId/:planningId/meetings/getList",
    name: RouteEnum.MEETING_LIST,
    component: MeetingList,
    beforeEnter: requireAuth,
    meta: { requiresAuth: true },
    props: (route) => ({
      ofObjId: Number(route.params.ofObjId),
      userAccountObjId: Number(route.params.userAccountObjId),
      planningId: Number(route.params.planningId),
    }),
  },
];

export default planningRoutes;
